export default "__VITE_ASSET__CNTwi$8T__"